import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Pageview, Restaurant } from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import CreateVenue from "../../licensing/Views/Venues/CreateVenue";
import Venue from "../../licensing/Models/Venue";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import { Link } from "react-router";
import Tooltip from "@mui/material/Tooltip";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIds: [],

      copyModal: false,
      newModal: false,
    };
  }

  /**
   * Modal functies
   */
  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDupliceerAction = (row) => {
    this.setState({
      selectedIds: [row[0]],
      copyModal: true,
    });
  };

  render() {
    const { classes } = this.props;

    const actions = [];

    actions.push({
      icon: Pageview,
      tooltip: <TranslationWrapper tKey={"Filter on"} />,
      action: (row) => {
        this.props.setFilter("vestiging.venue_id", {
          field: "vestiging.venue_id",
          operator: "=",
          value: row[0],
          label: row[1],
        });
        this.props.setFilter("venue_id", {
          field: "venue_id",
          operator: "=",
          value: row[0],
          label: row[1],
        });
      },
    });

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"All venues"} tKey={"venues.pagetitle"} />} />
        <GridContainer>
          <GridItem xs={12}>
            <AuthenticationWrapper permissionKey={"venues.create"}>
              <Button
                className={classes.marginRight}
                color={"success"}
                onClick={() => {
                  const [openDialog] = this.context;
                  openDialog({
                    children: (
                      <CreateVenue
                        onChange={(venue) => {
                          return new Promise((resolve, reject) => {
                            venue
                              .apiCreate()
                              .then(({ venue }) => {
                                resolve(venue);
                              })
                              .catch(() => {
                                reject();
                              });
                          });
                        }}
                        venue={new Venue()}
                      />
                    ),
                  });
                }}
              >
                <Add className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"New venue"} tKey={"venues.nieuw.item"} />
              </Button>
            </AuthenticationWrapper>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"name"}
              fieldKey={"venues:name"}
              operator={"like"}
              placeholder={getTranslation("venues.filters.venue", "Filter op venue")}
            />
          </GridItem>
          <GridItem md={4} xs={12}>
            <TextFilter field={"id"} fieldKey={"venues:id"} placeholder={getTranslation("venues.venue_id", "#")} />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "name", editable: false },
                {
                  customData: (venue) => {
                    return venue;
                  },
                  customRender: (venue) => {
                    let latestSubscription = venue.subs_subscriptions.reduce((result, subscription) => {
                      if (result?.start_date_unix > subscription.start_date_unix) {
                        return result;
                      } else {
                        return subscription;
                      }
                    }, null);

                    if (latestSubscription) {
                      if (latestSubscription.start_date_unix <= new Date().getTime()) {
                        if (
                          latestSubscription.end_date_unix == null ||
                          latestSubscription.end_date_unix > new Date().getTime()
                        ) {
                          return (
                            <Link to={"../subssubscriptions/" + latestSubscription.id + "/edit"}>
                              <Tooltip placement={"bottom"} title={"Open"}>
                                <Button color={"primary"} simple>
                                  {latestSubscription.status}
                                </Button>
                              </Tooltip>
                            </Link>
                          );
                        }
                      }

                      return (
                        <Link to={"../subssubscriptions/" + latestSubscription.id + "/edit"}>
                          <Tooltip placement={"bottom"} title={"Open"}>
                            <Button color={"primary"} simple>
                              ENDED
                            </Button>
                          </Tooltip>
                        </Link>
                      );
                    }
                    return (
                      <Link to={"../subssubscriptions/create"}>
                        <Tooltip placement={"bottom"} title={"Open"}>
                          <Button
                            className={classes.marginRight}
                            color={"success"}
                            onClick={() => {
                              this.props.setFilter("venue_id", {
                                field: "venue_id",
                                operator: "=",
                                value: Number(venue.id),
                                label: venue.name,
                              });
                              this.props.setFilter("vestiging.venue_id", {
                                field: "vestiging.venue_id",
                                operator: "=",
                                value: Number(venue.id),
                                label: venue.name,
                              });
                            }}
                          >
                            <Add className={classes.icons} /> Create license
                          </Button>
                        </Tooltip>
                      </Link>
                    );
                  },
                },
                { dbfield: "subs_price_plan.id", hide: true },
              ]}
              dbfields={
                "id,name,subs_subscriptions.venue_id,subs_subscriptions.id,subs_subscriptions.status,subs_subscriptions.start_date_unix,subs_subscriptions.end_date_unix"
              }
              delete={"venues.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"venues/:id/edit"}
              fetchUrl={"core/venue"}
              filters={this.props.filters}
              headerIcon={<Restaurant />}
              headers={[
                {
                  label: getTranslation("venues.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("venues.table.name", "Naam"),
                  sortable: true,
                  sortKey: "name",
                },
                {
                  label: getTranslation("Subscription status"),
                  sortable: false,
                },
              ]}
              reduxKey={"venue"}
              tableTitle={<TranslationWrapper tDefault={"Venues"} tKey={"venues.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

Index.contextType = DialogContext;

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["venues:name"]) {
    filters["venues:name"] = state.filtersV2["venues:name"];
  }
  if (state.filtersV2["venues:id"]) {
    filters["venues:id"] = state.filtersV2["venues:id"];
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, vestigingStyle));
